import { RefreshDouble } from 'iconoir-react';
import React from 'react';

import { IconPropsInterface } from './Icon.types';

interface RefreshDoubleIconProps extends IconPropsInterface {
  color?: string;
  size?: string;
}

const RefreshDoubleIcon: React.FC<RefreshDoubleIconProps> = ({
  color = 'black',
  size = '24px',
  ...rest
}) => {
  return <RefreshDouble width={size} height={size} color={color} {...rest} />;
};

RefreshDoubleIcon.displayName = 'RefreshDoubleIcon';

export default RefreshDoubleIcon;
